module.exports = __webpack_public_path__ + "img/pproducts.1feb0262.png";